<template>
  <el-dialog title="填入历史记录" :visible.sync="showHistoryRecord" width="600px" :modal-append-to-body="true" :append-to-body="true" :before-close="handleClose">
    <div class="history-record">
      <p class="record-title">请选择需要填入的“其他”历史记录数据</p>
      <el-table :data="factorList" style="width: 96%;margin:0 auto" ref="multipleTable" 
        class="history-record-table">
        <!-- <el-table-column type="selection" width="55">
        </el-table-column> -->
        <el-table-column prop="eventDate" label="时间" align="center">
        </el-table-column>
        <el-table-column prop="eventName" label="诊疗类型" align="center">
        </el-table-column>
        <el-table-column prop="eventType" label="记录类型" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.eventType | recordTypeFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inputValue" label="字段值" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleSelect(scope.row)" type="text" size="small">选用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination style="text-align:right;margin-right:30px;margin-top:20px" background
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="current"
        :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total" size="mini">
      </el-pagination> -->
    </div>
    <el-row class="dialog-footer-total">
      <el-col :span="4">
        共{{factorList.length}}条
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { getHistoryEvent } from "@/api/crossreentry";
export default {
  props: {
    showHistoryRecord: {
      type: Boolean,
      default: false
    },
    selectStandardRow: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    recordTypeFilter(value) {
      switch (value) {
        case 1:
          return "病历";
        case 2:
          return "处方";
        case 3:
          return "手术";
        case 4:
          return "检验";
        case 5:
          return "检查";
        
        case 6:
          return "化疗记录单";
        case 7:
          return "急诊留观记录";
        case 8:
          return "急诊抢救记录";
        case 9:
          return "24h出入院记录";
        case 10:
          return "入院记录";
        
        case 11:
          return "住院病程记录";
        case 12:
          return "出院小结";
        case 13:
          return "筛查评估单";
        case 14:
          return "线下随访（除门诊外）";
        case 15:
          return "其他";
        case 16:
          return "会诊";
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      factorList: [],
      current: 1,
      size: 10,
      total: 0,
      selectData: {}
    };
  },
  created() {
    this.getHistoryEventData()
  },
  methods: {
    handleSelect(row) {
      this.selectData = row
      if (this.selectStandardRow.standardFieldName == '省市区' || this.selectStandardRow.dataType == '多选' || this.selectStandardRow.dataType == '多选下拉') {
        this.selectData.inputValue = this.selectData.inputValue.split(',')
      }
      this.selectStandardRow.inputValue = this.selectData.inputValue
      this.$emit('closeHistoryRecord')
    },
    // handleCurrentRow(row) {
    //   console.log(row)
    //   this.selectData = row
    // },
    async getHistoryEventData() {
      let res = await getHistoryEvent({
        patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
        standardFieldId: this.selectStandardRow.standardFieldId
      })
      if (res.code == 0) {
        this.factorList = res.data
      }
    },
    // confirmAddHistory() {
    //   if (JSON.stringify(this.selectData) == '{}') {
    //     this.$message.error('请选择填入的历史记录')
    //     return
    //   }
    //   if (this.selectStandardRow.standardFieldName == '省市区' || this.selectStandardRow.dataType == '多选' || this.selectStandardRow.dataType == '多选下拉') {
    //     this.selectData.inputValue = this.selectData.inputValue.split(',')
    //   }
    //   this.selectStandardRow.inputValue = this.selectData.inputValue
    //   // this.$emit('receiveStandardValue',this.selectData[0].inputValue)
    //   this.$emit('closeHistoryRecord')
    // },
    handleClose(done) {
      // this.$confirm("确认关闭？")
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
      this.$emit('closeHistoryRecord')
    },
    // select(selection, row) {
    //   // 清除 所有勾选项
    //   this.$refs.multipleTable.clearSelection();
    //   // 当表格数据都没有被勾选的时候 就返回
    //   // 主要用于将当前勾选的表格状态清除
    //   if (selection.length == 0) return;
    //   this.$refs.multipleTable.toggleRowSelection(row, true);
    // },
    // // 表格的选中 可以获得当前选中的数据
    // selectionChange(val) {
    //   // 将选中的数据存储起来
    //   this.selectData = val;
    // },
    // // 表格某一行的单击事件
    // rowClick(row, column) {
    //   const selectData = this.selectData;
    //   this.$refs.multipleTable.clearSelection();
    //   if (selectData.length == 1) {
    //     selectData.forEach(item => {
    //       // 判断 如果当前的一行被勾选, 再次点击的时候就会取消选中
    //       if (item == row) {
    //         this.$refs.multipleTable.toggleRowSelection(row, false);
    //       }
    //       // 不然就让当前的一行勾选
    //       else {
    //         this.$refs.multipleTable.toggleRowSelection(row, true);
    //       }
    //     });
    //   } else {
    //     this.$refs.multipleTable.toggleRowSelection(row, true);
    //   }
    // },
    // // 分页
    // handleSizeChange(val) {
    //   this.size = val;
    //   this.getList();
    // },
    // handleCurrentChange(val) {
    //   this.current = val;
    //   this.getList();
    // }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding-top: 20px;
}
.history-record {
  .record-title {
    margin-bottom: 10px;
    text-align: center;
    line-height: 2;
    color: #333333;
  }
  .record {
    padding: 10px 0;
  }
}

.dialog-footer-total {
  padding: 10px 0 0 20px;
  line-height: 28px;
  color: #666666;
}

/deep/.history-record-table th {
  background: #fafafa;
  border: none;
}
/deep/.history-record-table th {
  border: none;
  text-align: center;
  color: #333333;
}
/deep/.history-record-table td {
  border-right: none;
  text-align: center;
  color: #333333;
  padding: 10.5px 0;
  border-bottom: 1px solid #e9e9e9;
}

/deep/.el-table__header-wrapper .el-checkbox {
  visibility: hidden;
}
</style>